import { Link, useLocation } from 'react-router-dom';

interface ServiceSubNavItem {
  label: string;
  path: string;
}

interface ServiceSubNavProps {
  items: ServiceSubNavItem[];
  backLabel: string;
  backPath: string;
  sectionLabel: string;
}

export default function ServiceSubNav({ items, backLabel, backPath, sectionLabel }: ServiceSubNavProps) {
  const location = useLocation();

  return (
    <section className="py-14 bg-[#f7faf7] border-t border-gray-100">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Back to overview */}
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h3 className="text-[#1a2e1a] font-bold text-[1.125rem]">{sectionLabel}</h3>
          <Link
            to={backPath}
            className="inline-flex items-center gap-2 text-[#4CAF50] hover:text-[#43a047] text-[0.9375rem] font-semibold transition-colors cursor-pointer group"
          >
            <i className="ri-arrow-left-line transition-transform duration-200 group-hover:-translate-x-0.5" />
            {backLabel}
          </Link>
        </div>
        {/* Sub-pages grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`bg-white rounded-xl p-5 border transition-all duration-200 cursor-pointer block hover:-translate-y-0.5 ${
                  isActive
                    ? 'border-[#4CAF50] bg-green-50'
                    : 'border-gray-100 hover:border-green-200'
                }`}
              >
                <p className={`font-bold text-[0.9375rem] ${isActive ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'}`}>
                  {item.label}
                </p>
                {isActive && (
                  <p className="text-[#4CAF50] text-[0.75rem] mt-1">目前頁面</p>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
